// import { userAccessPolicyConstants } from "../constants";

import { IStaffDepartment } from "../interfaces-and-types";

export function userHasAccessRight(
  claim: string, // keyof typeof userAccessPolicyConstants,
  active_tenant_id: string | null,
  staff_departments: IStaffDepartment[] // (keyof typeof userAccessPolicyConstants)[]
): boolean {
  const userAccessContainer = staff_departments.find(
    (d) => d.merchant_id === active_tenant_id
  );

  return !userAccessContainer
    ? false
    : userAccessContainer.department_access_policies.find(
        (cl) => cl === claim
      ) !== undefined;
}

export function getUserDepartment(
  active_tenant_id: string | null,
  staff_departments: IStaffDepartment[]
): IStaffDepartment | undefined {
  const userAccessContainer = staff_departments.find(
    (d) => d.merchant_id === active_tenant_id
  );

  return userAccessContainer;
}
